import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { GeneralService } from 'src/app/shared/services/general.service';
import { AuthService } from 'src/app/core/auth/auth.service';
import { HttpService } from 'src/app/core/http/http.service';
import { API } from 'src/app/configs';
import { AppLoadingService } from 'src/app/shared/services/apploading.service';
//import { MAT_STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { Subscription } from 'rxjs';
import { City } from 'src/app/shared/models/city';
import { Address } from 'src/app/shared/models/address';
import { AbstractForm } from 'src/app/shared/utils/abstract-form';

@Component({
  selector: 'complete-signup',
  templateUrl: './complete-signup.component.html',
  styleUrls: ['./complete-signup.component.scss'],
/*  providers: [{
    provide: MAT_STEPPER_GLOBAL_OPTIONS, useValue: { displayDefaultIndicatorType: false }
  }]
  */
})
export class CompleteSignupComponent implements OnInit, OnDestroy {
  
  @Input() state: any = '';

  formGroup: FormGroup;

  signUpSubmit = false;
  signUpSubmited = false;
  signUpSent = false;

  title = 'Complete seu cadastro';
  username = '';
  
  message:String = '';

  creciFront = [];
  creciVerse = [];

  personData:any = {};

  documentFront = [];
  documentVerse = [];

  infoForm: AbstractForm[] = [];
  infoGroup: FormGroup;

  personId = null;

  generalDataSubscription : Subscription;

  constructor(
    private _formBuilder: FormBuilder,
    private auth:AuthService,
    private httpService: HttpService,
    protected gs : GeneralService,
    protected als: AppLoadingService) {
      this.generalDataSubscription = this.gs.generalData$.subscribe(result=>{
        if(!!result?.person?.length){
          this.personData = result?.person[0];
          this.setPersonData();
        }
      })
   }

  ngOnInit() {
    this.formGroup = this._formBuilder.group({
      firstCtrl: ['', Validators.required]
    });
    this.signUpSent = this.state == 'SignUpRequiredCompleteSent';

    if(this.signUpSent)
      this.title = 'Cadastro em validação';

    
  }

  setPersonData(){
    
    if(this.personData.status == '1' && this.personData.creci_verified == '-1' && this.personData.perfil_id == '3'){
      this.signUpSent = true;
      this.title = '';
    }
      
    this.personId = this.personData.person_id;
    this.username = this.getUserdata()?.firstname;
    this.state = this.gs.getSignUpState();

    let city = new City();
    city.id = this.personData.address_city_id;
    city.name = this.personData.address_city_name;
    city.state = this.personData.address_state_id;

    this.personData.address = new Address(
      '',
      this.personData.address_zipcode,
      city,
      this.personData.address_street,
      this.personData.address_number,
      this.personData.address_complement,
      this.personData.address_district,
      this.personData.address_latitude,
      this.personData.address_longitude,
    0);
  }

  ngOnDestroy(){
    this.generalDataSubscription?.unsubscribe();
  }

  getUserdata(){
    return this.auth.getUserdata();
  }

  getSectionImageUrl(file) {
    switch(file){
      case 'id':
        return this.gs.buildImagemUrl('id-asset.png');
      case 'creci':
        return this.gs.buildImagemUrl('creci-asset.png');

    }
  }
  
  send(){
    let files = this.documentFront.concat(this.documentVerse);//.concat(this.creciFront).concat(this.creciVerse);
    
    if(files.length < 2){
      this.gs.error({}, 'Complete as etapas corretamente');
      return;
    }
    
    let filesIds = [];
    files.map(item=> filesIds.push(item.file_id));
    let data = {state:'SignUpRequiredCompleteSent', files : filesIds};
   
    this.signUpSubmit = true;

    this.httpService.post<any>(API.user.general.creci, data)
      .then(result => {
        this.signUpSubmited = true;
        this.title = '';
        //this.gs.doConfirmSignedIn(false);
      })
      .catch((err) => this.gs.error(err))
      .finally(() => {
        this.signUpSubmit = false;
      });
  }

  receiveEvent(form: AbstractForm|any): void {
    if(form instanceof AbstractForm){
      this.infoGroup = form.formGroup;
    } else if(form=='dirty') {
      this.infoGroup.markAsDirty();
    }
  }

  sendInfo(){
    if(this.infoGroup.value.zipcode?.length < 10)
      return this.gs.error({}, 'Preencha os campos corretamente');

    this.httpService.put<any>(API.profile.general.base, {address:{zipcode:this.infoGroup.value.zipcode}})
    .then(result => {
      this.gs.error({}, 'Operação concluída');
      this.gs.doConfirmSignedIn();
    })
    .catch((err) => this.gs.error(err));
  }

}
